var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { forwardRef, useCallback, useContext, useRef, useState } from 'react';
import { Pressable, View } from 'react-native';
import { StateConfigContext } from '../../providers';
import { getTestId } from '../../utils';
import { DynamicSvg } from '../dynamic-svg';
import { Loader } from '../loader';
import { Typography } from '../typography/Typography';
import { getButtonIconColor, getButtonIconSize, getButtonLoaderProps, getButtonProps, getButtonStyles, getButtonTitleTypes } from './ButtonStyles';
export var Button = forwardRef((props, ref) => {
  var stateContext = useContext(StateConfigContext);
  var buttonProps = getButtonProps(props, stateContext);
  var buttonLoaderProps = getButtonLoaderProps(buttonProps);
  var stylesBasedOnState = useRef();
  var _useState = useState(false),
    isThrottled = _useState[0],
    setIsThrottled = _useState[1];
  var disabled = buttonProps.disabled,
    iconName = buttonProps.iconName,
    iconProps = buttonProps.iconProps,
    controlState = buttonProps.controlState,
    style = buttonProps.style,
    title = buttonProps.title,
    size = buttonProps.size,
    showLoader = buttonProps.showLoader,
    _buttonProps$testID = buttonProps.testID,
    testID = _buttonProps$testID === void 0 ? 'Button' : _buttonProps$testID,
    titleProps = buttonProps.titleProps,
    onPress = buttonProps.onPress,
    _buttonProps$enableTh = buttonProps.enableThrottlePress,
    enableThrottlePress = _buttonProps$enableTh === void 0 ? false : _buttonProps$enableTh,
    _buttonProps$throttle = buttonProps.throttleDurationMs,
    throttleDurationMs = _buttonProps$throttle === void 0 ? 1000 : _buttonProps$throttle,
    restProps = __rest(buttonProps, ["disabled", "iconName", "iconProps", "controlState", "style", "title", "size", "showLoader", "testID", "titleProps", "onPress", "enableThrottlePress", "throttleDurationMs"]);
  var isDisabled = disabled || controlState === 'disabled' || isThrottled;
  var getButtonPressableStyles = useCallback(event => {
    var styles = getButtonStyles(event, buttonProps, isThrottled);
    stylesBasedOnState.current = styles;
    return [styles.container, style];
  }, [buttonProps]);
  var handlePress = event => {
    if (isThrottled || showLoader) return;
    onPress === null || onPress === void 0 ? void 0 : onPress(event);
    if (enableThrottlePress) {
      setIsThrottled(true);
      setTimeout(() => {
        setIsThrottled(false);
      }, throttleDurationMs);
    }
  };
  return _jsx(_Fragment, {
    children: !!title && _jsx(Pressable, Object.assign({
      ref: ref,
      accessibilityRole: "button",
      disabled: isDisabled,
      style: getButtonPressableStyles,
      onPress: handlePress,
      accessibilityState: {
        busy: showLoader,
        disabled: isDisabled
      }
    }, restProps, getTestId(testID), {
      children: event => {
        var _a;
        return _jsxs(View, Object.assign({
          style: stylesBasedOnState.current.buttonLoaderContainer
        }, {
          children: [_jsxs(View, Object.assign({
            style: stylesBasedOnState.current.buttonIconContainer
          }, {
            children: [!!iconName && _jsx(DynamicSvg, Object.assign({
              iconName: iconName,
              color: getButtonIconColor(event, buttonProps),
              style: stylesBasedOnState.current.buttonIcon,
              fontSize: getButtonIconSize(buttonProps)
            }, iconProps, getTestId(testID, 'icon'))), _jsx(Typography, Object.assign({
              text: title,
              type: getButtonTitleTypes(size),
              style: (_a = stylesBasedOnState === null || stylesBasedOnState === void 0 ? void 0 : stylesBasedOnState.current) === null || _a === void 0 ? void 0 : _a.buttonText
            }, titleProps, getTestId(testID, 'title')))]
          })), showLoader && _jsx(Loader, Object.assign({}, buttonLoaderProps, getTestId(testID, 'loader')))]
        }));
      }
    }))
  });
});